import apiClient from "../../../services/apiClient";
import { TransformFilters } from '../../../utils';
import { QueryKey } from "@tanstack/react-query";
import { Item, RefundsFilter, RefundsRequest, RefundsResponse } from "../types/refunds-response";
import { useCustomToast } from "../../../components";

const { showToast } = useCustomToast();

export const refundsReqAPI = {
  gets: async (filters: any): Promise<RefundsResponse> => {
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get('/api/petition/refund', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return response.data;
  },
  get: async (id: string): Promise<RefundsRequest> => {
    const response = await apiClient.get(`/api/petition/refund/${id}`);
    return response.data;
  },
  getItems: async (id: string): Promise<Item[]> => {
    const response = await apiClient.get(`/api/petition/refund/${id}/items`);
    return response.data;
  },
  put: async (
    id: string,
    data: Record<string, RefundsRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/refund/${id}`, data);
    return response.data;
  },
  post: async (req: RefundsRequest): Promise<void> => {
    const response = await apiClient.post(
      '/api/petition/refund',
      {
        ...req,
        documents: req?.documents?.map((doc) => doc?.file) || [],
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
  
  cancel: async (req: any): Promise<void> => {
    const response = await apiClient.post(
      `/api/petition/refund/cancel/${req.id}`,
      {
        observations: req.observations,
      }
    );
    return response.data;
  },

  export: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/refund/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `reintegros_exportados.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      throw error;
    }
  },
  voucher: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get(`/api/petition/refund/pdf/${id}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'voucher_refund.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showToast('success', 'Descarga de comprobante exitosa');

    } catch (error) {
      showToast('error', 'Falló descarga de archivo.');
    }
  },
  manageItems: async (
    data: Record<string, RefundsRequest>
  ): Promise<any> => {
    const response = await apiClient.put(`/api/petition/refund/manageItems`, data);
    return response;
  },
  manage: async (
    id: number,
    data: Record<string, any>
  ): Promise<any> => {
    const response = await apiClient.put(`/api/petition/refund/${id}`, data);
    return response;
  },
};
